//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ConvertType",1,0],[0,"KeepSheet",1,0],[0,"PartingColor",1,0],[0,"PatchColor",1,0],[1,"PatchSurfaces",0,"SelectBodyList",0],[0,"Type",1,0]],[[["redValue","greenValue","blueValue"],"GetPatchColor",{},0,1],[["redValue","greenValue","blueValue"],"SetPatchColor",{},3,1],[["addFace"],"AddSelectFace",{},1,0],[[],"InitOnEnter",{},0,0],[[],"UpdateInitialCandidates",{},0,0],[["sheets"],"PrepareAllRemovingSheets",{},1,0],[[],"ClearAddingCandidates",{},0,0],[[],"GetNewCavityAndCorePartingProcessStatus",{R_:{newCavityAndCorePartingProcessStatus:''}},0,0]],[]];
SPLM.Tooling.AssignPatchBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.AssignPatchBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.AssignPatchBuilder.Types = Object.freeze({
    "PatchSurface" : "PatchSurface", "PartingSurface" : "PartingSurface"});

SPLM.Tooling.AssignPatchBuilder.ConvertTypeOption = Object.freeze({
    "WithCopies" : "WithCopies", "NoCopies" : "NoCopies"});

export default SPLM;